import { render, staticRenderFns } from "./AddToList.vue?vue&type=template&id=37dec134"
import script from "./AddToList.vue?vue&type=script&lang=js"
export * from "./AddToList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports